import { type ConsumerCheckoutCartsResponse, useShowConsumerCheckout } from '@givebacks/api/store';
import { AdditionalFieldsFormsGuard } from 'ui/Core';

type CheckoutAddressFormProps = {
  checkoutId: string;
};

const getMailingAddressFields = (data?: ConsumerCheckoutCartsResponse) => {
  return data?.checkout.carts.find((cart) =>
    cart.cart_options?.some((option) => option.type === 'address')
  )?.cart_options;
};

const CheckoutAddressForm = ({ checkoutId }: CheckoutAddressFormProps) => {
  const { data: requiredFields } = useShowConsumerCheckout({
    checkoutId,
    select: getMailingAddressFields,
  });
  if (!requiredFields) return null;
  return (
    <AdditionalFieldsFormsGuard
      selectOptions={['address']}
      options={requiredFields}
      formId="additional_fields_address"
    />
  );
};

export { CheckoutAddressForm };
